import { useMemo } from 'react'
import { ModelPromiseClient } from '@trustero/trustero-api-web/lib/model/model_grpc_web_pb'
import {
  Controls,
  GetControlsForComplianceFrameworkRequest,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { GrpcResponse, NewGrpcResponse } from '../hooks/types'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'
import { useNewModel } from '../hooks/useNewModel'

export const useControlsForComplianceFramework = (
  complianceFrameworkId: string,
  shouldFetch = true,
): GrpcResponse<Controls> => {
  const newModel = useNewModel()
  const request = useMemo(() => {
    const req =
      new GetControlsForComplianceFrameworkRequest().setComplianceFrameworkId(
        complianceFrameworkId,
      )
    if (newModel) {
      req.setUseNewModel(newModel)
    }
    return req
  }, [newModel, complianceFrameworkId])
  const { response } = useSwrImmutableGrpc(
    ModelPromiseClient.prototype.getControlsForComplianceFramework,
    request,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}
